<template>
    <div>
        <div class="col-sm-12">
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px"
                    >{{ $t('landingPage.settingApplicationMethod.titleBlock') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-10">
                    {{ dataForm.block_application_method.title_block }}
                    <div class="mt-3">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                            <div class="col-sm-3">
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    {{ `${dataForm.block_application_method.size_title}px` }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                            <div class="col-sm-3">
                                <InputText
                                    style="max-width: 100px"
                                    :model.sync="dataForm.block_application_method.color_title"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    disabled
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-3">
                                <InputText
                                    style="max-width: 100px"
                                    :model.sync="dataForm.block_application_method.background_title"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.imgTitleLPforPrize') }}</label>
                <div class="col-sm-10">
                    <div v-if="dataForm.block_application_method.title_image?.path" style="width: 200px; height: 200px" class="position-relative">
                        <b-img
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.block_application_method.title_image?.path"
                            :alt="dataForm.block_application_method.title_image.origin_name"
                            style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                        ></b-img>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationMethod.background') }}</label>
                <div class="col-sm-10">
                    <div
                        v-if="dataForm.block_application_method.background_image?.path"
                        style="width: 200px; height: 200px"
                        class="position-relative"
                    >
                        <b-img
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.block_application_method.background_image?.path"
                            :alt="dataForm.block_application_method.background_image.origin_name"
                            style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                        ></b-img>
                    </div>
                    <div class="my-3">
                        <InputText
                            style="max-width: 100px"
                            :model.sync="dataForm.block_application_method.background_color"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                            :disabled="true"
                        />
                    </div>
                    <div>
                        <InputCheckBox
                            :model.sync="dataForm.block_application_method.is_repeat"
                            :id="`check-repeat-background-app_method`"
                            :value="dataForm.block_application_method.is_repeat"
                            :label="`repeat`"
                            :disabled="true"
                        />
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationMethod.style') }} </label>
                <div class="col-sm-10">
                    <div style="width: 100px; height: 80px">
                        <img
                            class="w-100 h-100"
                            style="object-fit: cover"
                            :src="dataForm.block_application_method.style?.image_preview"
                            :alt="dataForm.block_application_method.style?.image_preview"
                        />
                    </div>
                    <div class="mt-3 body__preview">
                        <div
                            class="block__application--methods"
                            :style="`background-color: ${dataForm.block_application_method?.background_color ?? ''};
                                    background-image: url(${dataForm.block_application_method?.background_image?.path ?? ''});
                                    background-repeat: ${dataForm.block_application_method?.is_repeat ? 'repeat' : 'no-repeat'};`"
                        >
                            <div :class="`box--methods__${dataForm.block_application_method.style?.id}`">
                                <div v-if="dataForm.block_application_method.title_image?.path" class="mb-5">
                                    <img
                                        :src="dataForm.block_application_method.title_image.path"
                                        :alt="dataForm.block_application_method.title_image.path"
                                        class="img__title"
                                    />
                                </div>

                                <div v-else style="padding-top: 5rem">
                                    <h2
                                        v-if="STYLE_SHOW_TITLE.includes(dataForm.block_application_method.style?.id)"
                                        class="title-common"
                                        :style="`background: ${dataForm.block_application_method?.background_title ?? ''};
                                                        color:  ${dataForm.block_application_method?.color_title ?? ''};
                                                        font-size: ${dataForm.block_application_method?.size_title}px;`"
                                    >
                                        <span>{{ dataForm.block_application_method.title_block }}</span>
                                    </h2>
                                    <h2 v-else class="title-common">
                                        <div
                                            class="title-eng"
                                            :style="`background: ${dataForm.block_application_method?.background_title ?? ''};
                                                            color:  ${dataForm.block_application_method?.color_title ?? ''};
                                                            font-size: ${dataForm.block_application_method?.size_title}px;`"
                                        >
                                            <span>{{ dataForm.block_application_method.title_block }}</span>
                                        </div>
                                        <!-- <div class="title-jp"></div> -->
                                    </h2>
                                </div>
                                <div class="list__method" v-html="dataForm.block_application_method.html_content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { truncateText } from '@/utils/format';
import { InputText, InputCheckBox } from '@/components/Input';
import { STYLE_SHOW_TITLE } from '../../../constants';

export default {
    name: 'SettingApplicationMethod',
    components: {
        InputText,
        InputCheckBox
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            STYLE_SHOW_TITLE: STYLE_SHOW_TITLE
        };
    },

    methods: {
        truncateTextTable(text, length) {
            return truncateText(text, length);
        }
    },
    watch: {},
    mounted() {}
};
</script>

<style lang="scss" scoped></style>
